import { forwardRef, FunctionComponent } from 'react';

import { IDropdownItem, Select } from '@smartshell/ui-kit';

import { ENDS } from 'cashbox';

import s from './NDSSelect.module.scss';

export interface INDSSelectProps {
  name?: string;
  className?: string;
  value: ENDS | null;
  onChange: (value: ENDS | null) => void;
  error?: string;
  disabled?: boolean;
  notBordered?: boolean;
}

const NDS_OPTIONS: Array<IDropdownItem<ENDS>> = [
  { value: ENDS.NO_NDS, title: 'Без НДС' },
  { value: ENDS.NDS_0, title: 'НДС 0%' },
  { value: ENDS.NDS_5, title: 'НДС 5%' },
  { value: ENDS.NDS_7, title: 'НДС 7%' },
  { value: ENDS.NDS_10, title: 'НДС 10%' },
  { value: ENDS.NDS_20, title: 'НДС 22%' },
  { value: ENDS.NDS_110, title: 'НДС 110%' },
  { value: ENDS.NDS_120, title: 'НДС 120%' },
];

export const NDSSelect: FunctionComponent<INDSSelectProps> = forwardRef<
  HTMLInputElement,
  INDSSelectProps
>(
  (
    {
      name = 'nds',
      className = '',
      error,
      notBordered,
      onChange,
      value,
      disabled,
    },
    ref
  ) => (
    <Select
      ref={ref}
      name={name}
      placeholder="Тип налога"
      value={value}
      onChange={onChange}
      options={NDS_OPTIONS}
      error={error}
      errorWrapperClassName={className}
      disableClear
      disabled={disabled}
      className={disabled ? s.disabled : undefined}
      bordered={!notBordered}
    />
  )
);
